
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { uMSALLogout } from "@account/util/msal";
@Component
export default class NotAuthorizedrorMSLogout extends Vue {
    logout() {
        uMSALLogout();
    }
}
